import React from "react";
import { Link } from "react-router-dom";
import { withStore } from "../../hocs";
import { observer } from "mobx-react";
// @ts-ignore
@withStore
@observer
export class FooterBottom extends React.Component {
  render() {
    let Width = window.innerWidth;
    // @ts-ignore
    const { store } = this.props;
    const { user } = store?.mainStore;
    let siteId = 3;
    if (user) {
      siteId = user.siteId;
    }

    return (
      <>
        <footer className="footer">
          <div className="grey">
            <div className="container">
              <div className="footer-lightblue-wrapper">
                <div className="footer-top">
                  <Link to={"/"} className="logo-footer">
                    <svg
                      width="199"
                      height="76"
                      viewBox="0 0 199 76"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M134.941 62.6558C133.037 62.6558 131.821 61.616 131.133 59.8876L137.885 47.7749C146.189 31.5032 164.365 -0.51363 164.196 0.00625505L142.901 59.8943C142.381 61.6228 140.997 62.6626 139.093 62.6626H134.941V62.6558Z"
                        fill="url(#paint0_linear_1219:14178)"
                      />
                      <path
                        d="M124.212 24.056C126.805 24.056 129.404 24.5759 130.62 28.0395L137.891 47.7681L142.908 59.8808C142.388 61.6092 141.004 62.649 139.1 62.649H134.947C133.043 62.649 131.828 61.6092 131.139 59.8808L116.259 26.8242C115.219 24.5759 116.603 24.056 118.163 24.056H124.212V24.056Z"
                        fill="url(#paint1_linear_1219:14178)"
                      />
                      <path
                        d="M179.218 69V73.4899C179.218 74.3339 178.881 74.5162 176.632 74.5229C174.384 74.5162 174.04 74.3271 174.04 73.4899V69H173V73.4899C173 73.814 173.007 74.0841 173.041 74.3069C173.182 75.2791 173.824 75.3872 176.626 75.3872C179.428 75.3872 180.069 75.2724 180.211 74.3069C180.245 74.0841 180.251 73.814 180.251 73.4899V69H179.218Z"
                        fill="#373737"
                      />
                      <path
                        d="M118.648 55.4043L110.013 35.7094C110.013 35.5339 109.844 35.3651 109.844 35.1895C109.668 35.014 109.668 34.8452 109.5 34.8452C108.98 34.1565 107.947 33.8122 107.258 33.8122H102.424C101.735 33.8122 101.384 34.3321 101.735 34.8452L113.996 60.7517C113.996 60.9272 114.165 61.096 114.165 61.2716C114.341 61.4471 114.341 61.6159 114.509 61.6159C115.198 62.3046 115.887 62.6489 116.751 62.6489H120.897C121.241 62.6489 121.585 62.6489 122.105 62.4734C122.274 62.4734 122.274 62.2978 122.449 62.2978C122.969 61.9535 123.489 61.4336 123.827 60.7449L126.595 54.8709L122.794 46.2354L118.648 55.4043Z"
                        fill="#373737"
                      />
                      <path
                        d="M83.5935 23.9682H78.4082C77.7195 23.9682 77.1996 24.4881 77.1996 25.3523V61.2784C77.1996 61.9671 77.7195 62.6625 78.4082 62.6625H83.5935C84.2822 62.6625 84.8021 62.1426 84.8021 61.2784V25.3523C84.7953 24.4881 84.2822 23.9682 83.5935 23.9682Z"
                        fill="#373737"
                      />
                      <path
                        d="M20.7211 39.6863C14.334 38.4777 9.15538 37.2691 9.15538 33.8122C9.15538 32.4281 9.67527 31.3951 10.7083 30.5309C11.7481 29.8422 13.1254 29.4911 15.0227 29.4911H23.4894C25.0423 29.4911 26.5952 29.8355 27.6349 30.3553C27.8105 30.5309 27.9793 30.5309 28.1548 30.6997C29.1946 31.2196 29.8833 32.0838 30.4032 33.1168C30.7475 33.981 31.2606 34.5009 31.6117 34.6697C32.1316 35.014 32.6515 35.1896 33.1646 35.1896H36.446C36.6215 35.1896 37.1347 35.014 37.4858 34.8453C37.8301 34.5009 38.1744 33.981 38.1744 33.1168C38.1744 30.3553 36.446 28.107 33.8533 26.3786C31.0918 24.6569 27.6349 23.6238 24.178 23.6238H16.9267C10.1884 23.6238 5.87403 24.8324 3.28135 26.7296C0.864225 28.6336 0 31.2196 0 34.5009C0 42.6165 10.5327 44.8649 18.9994 46.5933C25.3866 47.9774 30.7407 49.0104 30.7407 52.4673C30.7407 53.8515 30.2209 54.8845 29.1878 55.7487C28.1481 56.4374 26.7707 56.7817 24.8667 56.7817H15.1982C13.6453 56.7817 12.0924 56.4374 11.0526 55.9175C10.8838 55.7419 10.7083 55.7419 10.5327 55.5731C9.49297 55.0533 8.80429 54.189 8.29116 53.156C7.77127 52.4673 7.42693 51.7719 6.90705 51.6031C6.38716 51.2588 5.87403 51.0832 5.35414 51.0832H1.904C1.72845 51.0832 1.21532 51.2588 0.864225 51.4276C0.519885 51.7719 0.175546 52.2918 0.175546 53.156C0.175546 55.9175 1.904 58.1658 4.48992 59.8943C7.25814 61.6227 10.7083 62.6557 14.1652 62.6557H22.8007C29.5389 62.6557 33.8533 61.4472 36.446 59.5499C38.8631 57.6527 39.7273 55.06 39.7273 51.7787C39.7206 43.4807 29.1878 41.408 20.7211 39.6863Z"
                        fill="#373737"
                      />
                      <path
                        d="M91.358 62.6558H96.5434C97.2321 62.6558 97.7519 62.1359 97.7519 61.2717V25.5211C97.7519 24.8324 97.2321 24.137 96.5434 24.137H91.358C90.6693 24.137 90.1495 24.6569 90.1495 25.5211V61.4472C90.1562 62.1359 90.6693 62.6558 91.358 62.6558Z"
                        fill="#373737"
                      />
                      <path
                        d="M73.2294 47.282C73.2294 42.4478 71.852 38.8221 69.2594 36.3982C66.6667 33.981 62.6966 32.5969 57.8624 32.5969C53.0281 32.5969 49.0581 33.981 46.4654 36.3982C43.8727 38.9909 42.3198 42.6165 42.3198 47.6264C42.3198 52.6362 43.6972 56.2618 46.4654 58.8545C49.0581 61.4472 53.0281 62.6558 57.8624 62.6558C62.3523 62.6558 66.1535 62.1359 68.5707 60.9273C70.8123 59.8943 72.1964 58.1658 72.1964 55.5732C72.1964 55.3976 72.1964 55.2288 72.0208 55.0533C71.852 54.8777 71.6765 54.8777 71.5009 54.8777H67.1798C66.6599 54.8777 66.1468 55.0533 65.8025 55.2221C65.4581 55.3976 65.1138 55.742 64.7627 56.0863C64.5871 56.2618 64.4183 56.4306 64.074 56.775C63.8985 56.9505 63.5541 57.1193 63.3853 57.2949C62.1768 57.9835 60.2795 58.3279 58.3755 58.3279C55.7828 58.3279 53.7101 57.808 52.3327 56.4306C50.9486 55.2221 50.2599 53.3248 50.0844 50.7322V49.5236H72.5407C72.5407 49.6991 73.0606 49.348 73.0606 49.348C73.2361 49.1725 73.2361 49.0037 73.2361 48.8282V47.282H73.2294ZM50.0844 45.7291V44.6961V44.5205C50.0844 43.8319 50.2599 43.312 50.2599 42.6233C50.4355 42.1034 50.6042 41.4147 50.7798 40.8948C51.9884 38.1334 54.2367 36.7493 57.6936 36.7493C60.1107 36.7493 62.0147 37.4379 63.2165 38.8221C64.4251 40.2062 65.1205 42.1034 65.2893 44.5205V45.5536L50.0844 45.7291Z"
                        fill="#373737"
                      />
                      <path
                        d="M161.138 33.6366H155.959C155.264 33.6366 154.751 34.1565 154.751 35.0207V61.2716C154.751 61.9603 155.271 62.6557 155.959 62.6557H161.138C161.827 62.6557 162.347 62.1358 162.347 61.2716V35.0207C162.515 34.3321 161.827 33.6366 161.138 33.6366Z"
                        fill="#373737"
                      />
                      <path
                        d="M197.752 62.6559C197.928 62.6559 198.096 62.6559 198.272 62.4803C198.447 62.3048 198.447 62.136 198.447 61.9605V45.7292C198.447 41.2393 197.239 38.1267 195.166 36.0607C193.093 33.9879 190.156 33.1237 186.699 33.1237C184.627 33.1237 183.074 33.468 181.514 34.1567C179.961 34.8454 178.753 35.8852 177.375 36.9182C176.855 37.2625 176.335 37.9512 175.647 38.4711C175.647 37.6069 175.647 36.3983 175.647 36.2228V34.4943C175.647 34.3188 175.647 34.15 175.471 33.9744C175.296 33.7989 175.127 33.7989 174.951 33.7989H168.564C168.395 33.7989 168.22 33.7989 168.044 33.9744C167.869 34.15 167.869 34.3188 167.869 34.4943V61.9537C167.869 62.1292 167.869 62.298 168.044 62.4736C168.22 62.6491 168.389 62.6491 168.564 62.6491H174.951C175.127 62.6491 175.296 62.6491 175.471 62.4736C175.647 62.298 175.647 62.1292 175.647 61.9537V42.7922C176.335 41.5837 178.928 39.6864 179.617 39.3353C180.994 38.4711 182.554 37.9512 184.276 37.9512C186.18 37.9512 187.732 38.6399 188.934 39.8484C189.974 41.057 190.663 43.1298 190.663 45.7225V61.9605C190.663 62.136 190.663 62.3048 190.838 62.4803C191.014 62.6559 191.183 62.6559 191.358 62.6559H197.752Z"
                        fill="#373737"
                      />
                      <path
                        d="M15.8937 75.3289H22.1121V74.4646H16.9335V72.5674H21.9433V71.7032H16.9335V69.9747H22.1121V69.1105H15.8937V75.3289Z"
                        fill="#373737"
                      />
                      <path
                        d="M46.1145 69.1105H45.0747V75.3289H51.1176V74.4646H46.1145V69.1105Z"
                        fill="#373737"
                      />
                      <path
                        d="M67.6996 74.4646H67.5308L65.1137 69.1105H64.2495L62.0011 74.4646H61.8323L59.2397 69.1105H58.1999L61.3057 75.3289H62.5143L64.7558 70.3191L66.9974 75.3289H68.206L71.143 69.1105H70.1032L67.6996 74.4646Z"
                        fill="#373737"
                      />
                      <path
                        d="M3.80124 71.8786C1.55966 71.703 1.21532 71.5342 1.21532 70.8456C1.21532 70.1569 1.38411 69.9813 3.80124 69.9813C5.87403 69.9813 6.21837 70.1569 6.21837 71.1899H7.25814C7.25814 69.8058 6.9138 69.1171 3.80124 69.1171C0.864225 69.1171 0.175546 69.2927 0.175546 70.8456C0.175546 72.0541 0.519885 72.7428 3.80124 72.7428C6.39391 72.7428 6.39391 72.9184 6.39391 73.7826C6.39391 74.6468 5.87403 74.8156 3.63244 74.8156C1.21532 74.8156 1.03977 74.64 1.03977 73.4315H0C0 74.9844 0.175545 75.6798 3.62569 75.6798C6.38716 75.6798 7.42693 75.5043 7.42693 73.7826C7.42693 72.2229 7.08259 72.0474 3.80124 71.8786Z"
                        fill="#373737"
                      />
                      <path
                        d="M31.9493 69.1105H30.9163V75.3289H36.9591V74.4646H31.9493V69.1105V69.1105Z"
                        fill="#373737"
                      />
                      <path
                        d="M97.0632 74.6402L91.3648 69.1105H89.9806V75.3289H90.8449V69.9747L96.5434 75.3289H97.9275V69.1105H97.0632V74.6402Z"
                        fill="#373737"
                      />
                      <path
                        d="M81.0007 69.1105H79.9677V75.3289H81.0007V69.1105Z"
                        fill="#373737"
                      />
                      <path
                        d="M158.72 68.9416C155.263 68.9416 155.095 69.2859 155.095 72.2229C155.095 75.1599 155.615 75.5043 158.72 75.5043C162.002 75.5043 162.346 75.1599 162.346 72.2229C162.515 69.4615 162.171 68.9416 158.72 68.9416ZM158.72 74.64C156.128 74.64 155.959 74.1202 155.959 72.2229C155.959 69.9746 156.128 69.8058 158.72 69.8058C161.313 69.8058 161.489 69.9813 161.489 72.2229C161.482 74.2957 161.306 74.64 158.72 74.64Z"
                        fill="#373737"
                      />
                      <path
                        d="M197.064 69.1105H191.71V75.3289H192.749V73.0805H197.07C198.279 73.0805 198.968 72.5606 198.968 71.1833C198.961 69.6304 198.272 69.1105 197.064 69.1105ZM197.064 72.2231H192.743V69.9747H197.064C197.584 69.9747 197.928 70.3191 197.928 71.1833C197.928 71.8787 197.584 72.2231 197.064 72.2231Z"
                        fill="#373737"
                      />
                      <path
                        d="M143.866 71.1833C143.866 69.9747 143.346 69.1105 142.138 69.1105H136.264V75.3289H137.303V73.0805H141.962C142.482 73.0805 143.002 73.4249 143.002 73.7692V75.3221H144.042V73.7692C144.042 73.0805 143.522 72.7294 143.177 72.5606C143.353 72.5674 143.866 72.2231 143.866 71.1833ZM141.624 72.2231H137.135V69.9747H141.624C142.144 69.9747 142.833 70.1503 142.833 71.1833C142.826 72.2231 142.313 72.2231 141.624 72.2231Z"
                        fill="#373737"
                      />
                      <path
                        d="M121.241 69.8058C123.658 69.8058 124.01 69.8058 124.01 71.1899H125.049C125.049 69.1171 124.529 68.9416 121.424 68.9416C118.142 68.9416 117.798 69.2859 117.798 72.2229C117.798 74.9844 118.318 75.5043 121.424 75.5043C124.705 75.5043 125.049 75.1599 125.049 73.0871V72.2229H120.904V73.0871H124.01C124.01 74.64 123.834 74.64 121.241 74.64C118.655 74.64 118.48 74.64 118.48 72.2229C118.48 69.9746 118.655 69.8058 121.241 69.8058Z"
                        fill="#373737"
                      />
                      <defs>
                        <linearGradient
                          id="paint0_linear_1219:14178"
                          x1="156.505"
                          y1="-11.6404"
                          x2="141.429"
                          y2="59.2797"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stopColor="#0090FF" />
                          <stop offset="1" stopColor="#003760" />
                        </linearGradient>
                        <linearGradient
                          id="paint1_linear_1219:14178"
                          x1="118.357"
                          y1="18.4359"
                          x2="142.587"
                          y2="67.7641"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stopColor="#0090FF" />
                          <stop offset="1" stopColor="#0080DD" />
                        </linearGradient>
                      </defs>
                    </svg>
                  </Link>
                </div>

                <div className="footer-bottom">
                  <div className="footer-item">
                    <p className="contact__title">Контакты</p>
                    <p className="contact__describe">
                      г. Минск, ул. А.Купревича, 14
                    </p>
                    <p className="contact__describe">Пн-Пт: 9.00-17.30</p>
                    <p className="contact__describe">postmaster@sellwin.by</p>
                  </div>

                  <div className="footer-item footer-item-phone">
                    <p className="contact__title">Телефон для связи</p>
                    <div>
                      <p className="contact__describe">+ 375 (17) 269-33-33</p>
                      <p className="contact__describe__mini">(городской)</p>
                    </div>
                    <div>
                      <p className="contact__describe">+ 375 (29) 397-57-37</p>
                      <p className="contact__describe__mini">(А1)</p>
                    </div>
                  </div>
                  <div className="footer-item" style={{ display: "grid" }}>
                    <Link to="/how-order" className="contact__title">
                      Как оформить заказ
                    </Link>
                    <Link to="/payment" className="contact__title">
                      Способ оплаты
                    </Link>
                    <Link to="/delivery" className="contact__title">
                      Способ доставки
                    </Link>
                    <Link to="/returnConditions" className="contact__title">
                      Возврат товара
                    </Link>
                  </div>
                  <div className="footer-item" style={{ display: "grid" }}>
                    <Link to="/privacy-policy" className="contact__title">
                      Политика обработки <br /> персональных данных
                    </Link>
                    {siteId === 1 ? (
                      <Link to="/loyalty" className="contact__title">
                        Программа лояльности
                      </Link>
                    ) : null}
                  </div>

                  <div className="footer-item footer-pay-img" ></div>

                  <div className="footer-item footer-soc-img" style={{width: 134}} >
                    <p className="contact__title">Наши соц-е сети </p>
                    <div className="item-img" style={{justifyContent: "space-around",display: "flex", alignItems: "center", margin: "auto", width: "100%"}}>
                      <a href={"https://www.facebook.com/sellwin.by"}>
                        <svg
                          width="34"
                          height="34"
                          viewBox="0 0 34 34"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect
                            className="bg-soc-footer"
                            width="34"
                            height="34"
                            rx="17"
                            fill="#074DB7"
                          />
                          <path
                            d="M21.1667 9.91671C21.1667 9.8062 21.1228 9.70022 21.0446 9.62208C20.9665 9.54394 20.8605 9.50004 20.75 9.50004H18.6667C17.6176 9.44779 16.5905 9.81287 15.8098 10.5155C15.029 11.2182 14.5582 12.2013 14.5 13.25V15.5H12.4167C12.3062 15.5 12.2002 15.5439 12.122 15.6221C12.0439 15.7002 12 15.8062 12 15.9167V18.0834C12 18.1939 12.0439 18.2999 12.122 18.378C12.2002 18.4561 12.3062 18.5 12.4167 18.5H14.5V24.0834C14.5 24.1939 14.5439 24.2999 14.622 24.378C14.7002 24.4561 14.8062 24.5 14.9167 24.5H17.4167C17.5272 24.5 17.6332 24.4561 17.7113 24.378C17.7894 24.2999 17.8333 24.1939 17.8333 24.0834V18.5H20.0167C20.1093 18.5014 20.1998 18.4718 20.2737 18.4159C20.3477 18.3601 20.4009 18.2812 20.425 18.1917L21.025 16.025C21.0416 15.9635 21.0438 15.8989 21.0315 15.8364C21.0192 15.7738 20.9927 15.7149 20.9541 15.6642C20.9155 15.6135 20.8657 15.5723 20.8086 15.5438C20.7516 15.5154 20.6888 15.5004 20.625 15.5H17.8333V13.25C17.8541 13.0438 17.9509 12.8526 18.105 12.714C18.2591 12.5753 18.4594 12.499 18.6667 12.5H20.75C20.8605 12.5 20.9665 12.4561 21.0446 12.378C21.1228 12.2999 21.1667 12.1939 21.1667 12.0834V9.91671Z"
                            fill="white"
                          />
                        </svg>
                      </a>
                      <a href={"https://www.instagram.com/sellwingroup/"}>
                        <svg
                          width="34"
                          height="34"
                          viewBox="0 0 34 34"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect
                            className="bg-soc-footer"
                            width="34"
                            height="34"
                            rx="17"
                            fill="#074DB7"
                          />
                          <path
                            d="M11.7858 10H22.1273C23.1094 10 23.9129 10.7271 23.9129 11.7856V22.1274C23.9129 23.1859 23.1094 23.913 22.1273 23.913H11.7858C10.8034 23.913 10 23.1859 10 22.1274V11.7856C10 10.7271 10.8034 10 11.7858 10ZM20.135 11.5458C19.7905 11.5458 19.5089 11.8275 19.5089 12.1722V13.6714C19.5089 14.016 19.7905 14.2978 20.135 14.2978H21.7076C22.0521 14.2978 22.334 14.016 22.334 13.6714V12.1722C22.334 11.8275 22.0521 11.5458 21.7076 11.5458H20.135ZM22.3405 15.8838H21.116C21.2319 16.262 21.2946 16.6627 21.2946 17.0773C21.2946 19.3915 19.3581 21.2674 16.9697 21.2674C14.5815 21.2674 12.6453 19.3915 12.6453 17.0773C12.6453 16.6625 12.7079 16.2619 12.8239 15.8838H11.5461V21.7608C11.5461 22.065 11.7949 22.314 12.0992 22.314H21.7877C22.092 22.314 22.3408 22.0651 22.3408 21.7608V15.8838H22.3405ZM16.9696 14.2188C15.4265 14.2188 14.1754 15.4309 14.1754 16.9263C14.1754 18.4217 15.4265 19.6338 16.9696 19.6338C18.5128 19.6338 19.7641 18.4217 19.7641 16.9263C19.7641 15.4309 18.513 14.2188 16.9696 14.2188Z"
                            fill="white"
                          />
                        </svg>
                      </a>
                      {/* <a href={'/'}>
                                           <svg width="34" height="34" viewBox="0 0 34 34" fill="none"
                                                xmlns="http://www.w3.org/2000/svg">
                                               <rect className="bg-soc-footer" width="34" height="34" rx="17"
                                                     fill="#074DB7"/>
                                               <g clipPath="url(#clip0_239:6389)">
                                                   <path
                                                       d="M15.7618 19.8972C14.5989 19.784 13.5505 19.5167 12.6528 18.8614C12.5414 18.7799 12.4264 18.7013 12.3248 18.6103C11.9319 18.2581 11.8923 17.8547 12.2032 17.439C12.4691 17.0833 12.9156 16.9881 13.3797 17.1924C13.4696 17.232 13.5552 17.2814 13.6372 17.3345C15.3101 18.4073 17.6083 18.437 19.2876 17.3827C19.4539 17.2637 19.6318 17.1666 19.8379 17.117C20.2386 17.021 20.6124 17.1584 20.8275 17.4857C21.0732 17.8594 21.07 18.2242 20.7673 18.5144C20.3029 18.9592 19.7444 19.2811 19.1239 19.5057C18.5371 19.718 17.8944 19.8249 17.2583 19.8959C17.3543 19.9934 17.3995 20.0413 17.4596 20.0976C18.3233 20.9076 19.1908 21.7142 20.0517 22.5267C20.345 22.8035 20.4063 23.1467 20.2448 23.4687C20.0682 23.8206 19.6729 24.0522 19.2854 24.0274C19.0398 24.0115 18.8483 23.8975 18.6782 23.7375C18.0264 23.1253 17.3623 22.5245 16.7237 21.9007C16.5379 21.7193 16.4485 21.7536 16.2845 21.9111C15.6287 22.5412 14.9623 23.1615 14.292 23.7784C13.991 24.0554 13.6328 24.1052 13.2837 23.947C12.9126 23.7791 12.6765 23.4256 12.6947 23.0703C12.7073 22.83 12.8339 22.6464 13.0107 22.4818C13.8654 21.6852 14.7179 20.8865 15.5706 20.0886C15.627 20.0355 15.6796 19.9792 15.7618 19.8972Z"
                                                       fill="white"/>
                                                   <path
                                                       d="M16.4701 17.0862C14.3956 17.0796 12.6945 15.4745 12.7066 13.5352C12.7185 11.5745 14.4207 9.99447 16.5156 9.99989C18.6148 10.0052 20.2997 11.6079 20.2892 13.589C20.2785 15.5243 18.5656 17.0929 16.4701 17.0862ZM18.3554 13.5399C18.3518 12.577 17.5302 11.8104 16.5006 11.8096C15.4623 11.8085 14.6333 12.589 14.6413 13.5607C14.649 14.5199 15.4777 15.2811 16.5101 15.2775C17.5395 15.2742 18.3589 14.5026 18.3554 13.5399Z"
                                                       fill="white"/>
                                               </g>
                                               <defs>
                                                   <clipPath id="clip0_239:6389">
                                                       <rect width="15" height="14" fill="white"
                                                             transform="translate(9 10)"/>
                                                   </clipPath>
                                               </defs>
                                           </svg>
                                       </a>*/}
                    </div>
                    <div>
                      <a
                        href={
                          "https://play.google.com/store/apps/details?id=com.sellwin.b2b"
                        }
                      >
                        <img src="/img/ico/googlePlay.png" width={"100%"} />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="blue">
            <div className="container">
              <div
                className="footer-blue-wrapper"
                style={Width < 768 ? { marginBottom: 5 } : {}}
              >
                <div className="footer-left-bottom">
                  <div className="footer-companyname">
                    <p className="companyname__describe">SELLWIN.BY</p>
                  </div>
                </div>

                <div className="footer-right-bottom">
                  <p className="companyname__describe">
                    Общество с ограниченной ответственностью "Сэльвин"
                    (Беларусь) © 2007-2023. Сайт предприятия реализован по
                    принципу ИНТЕРНЕТ-ВИТРИНЫ. Здесь представлены образцы
                    товаров, продажа осуществляется со склада в Минске, возможен
                    заказ по телефону/факсу или через сайт, оплата по
                    безналичному расчету. Юридический адрес предприятия:
                    Беларусь, 220084, г. Минск, ул. А. Купревича, д.14. Дата
                    регистрации: 14.12.1994 Мингорисполком, УНП №100819821. Дата
                    регистрации в торговом реестре 19.07.2023 №561588. Время
                    работы с 9.00 до 17.30 .
                  </p>
                </div>
                <div
                  className="footer-right-bottom"
                  style={Width > 768 ? {} : { display: "none" }}
                >
                  <p className="companyname__describe">
                    <img
                      src="/img/ico/pic--payment-icons.png"
                      width={"100%"}
                      alt=""
                    />
                  </p>
                </div>
              </div>
              <div
                className="footer-blue-wrapper"
                style={Width > 768 ? { display: "none" } : {}}
              >
                <div className="footer-right-bottom">
                  <p className="companyname__describe">
                    <img
                      src="/img/ico/pic--payment-icons.png"
                      width={"100%"}
                      alt=""
                    />
                  </p>
                </div>
              </div>
            </div>
          </div>
        </footer>
      </>
    );
  }
}
